import React from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Colors from "../../../constants/Colors";

interface BackButtonProps {
  text?: string;
  onClick: () => void;
  color?: string;
  style?: React.CSSProperties;
}

export const BackButton: React.FC<BackButtonProps> = ({
  text = "Voltar para a página inicial",
  onClick,
  color = Colors.SPM600,
  style,
}) => {
  return (
    <div
      onClick={onClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        color: color,
        fontWeight: 600,
        fontSize: "14px",
        cursor: "pointer",
        marginBottom: "16px",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        userSelect: "none",
        ...style,
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLElement).style.opacity = "0.8";
        (e.currentTarget as HTMLElement).style.transform = "translateX(-2px)";
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLElement).style.opacity = "1";
        (e.currentTarget as HTMLElement).style.transform = "translateX(0px)";
      }}
    >
      <ArrowBackIosIcon style={{ fontSize: "12px", color: color }} />
      <span>{text}</span>
    </div>
  );
};

export default BackButton;
